<template>
    <transition name="el-fade-in-linear">
        <div v-show="showMain" class="transition-box">
            <div id="formblock">
                <el-form label-position="top" label-width="80px" :model="searchForm">
                    <el-row :gutter="30">
                        <el-col :span="5">
                            <el-form-item label="品牌名稱">
                                <el-select v-model="searchForm.BRAND_NAME" clearable filterable allow-create style="width:100%;">
                                    <el-option label="全部顯示" value=""></el-option>
                                    <el-option v-for="item in brandOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="公司/門店代號">
                                <el-input v-model="searchForm.VENDOR_ID"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="公司/門店名稱">
                                <el-input v-model="searchForm.NAME"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="合約同意狀態">
                                <el-select v-model="searchForm.AGREE_TIME" style="width:100%;">
                                    <el-option label="已同意" value="Y"></el-option>
                                    <el-option label="未同意" value="N"></el-option>
                                    <el-option label="全部顯示" value=""></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <el-row type="flex" justify="center">
                    <el-col :span="6" style="margin-top:auto;margin-bottom:auto;">
                        <el-button style="width: 100%" type="primary" @click="onSearch" v-show="store.getters.check_auth('SEARCH')">Search</el-button>
                    </el-col>
                </el-row>
            </div>
            <div id="datablock">
                <el-row type="flex" justify="end">
                    <el-button type="primary" round plain @click="onAddClick()" v-show="store.getters.check_auth('ADD')">新增</el-button>
                </el-row>

                <div ref="table" style="margin-top:10px;"></div>
            </div>

            <!--公司/門店資料-->
            <el-dialog :title="dialogTitle" width="40%" v-model="dialogFormVisible" top="1vh"
                       @opened="onDialogOpen" center :lock-scroll="false" :close-on-click-modal="false" style="height: 98vh; margin-bottom: 1vh">
                <el-form :model="form" :rules="rules" ref="formRef" :inline-message="true" label-position="top">
                    <el-scrollbar height="calc(98vh - 171px)" wrap-style="overflow-x:hidden;">
                        <el-row :gutter="30">
                            <el-col :span="12">
                                <el-form-item label="公司/門店代號" prop="VENDOR_ID">
                                    <el-input v-model="form.VENDOR_ID" disabled></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="餐飲平台" prop="CUST_CODE">
                                    <el-select v-model="form.CUST_CODE" style="width:100%;" :disabled="Roledisabled">
                                        <el-option v-for="item in custcodeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="公司/門店狀態" prop="DISABLE_FG">
                                    <el-select v-model="form.DISABLE_FG" style="width:100%;">
                                        <el-option label="啟用中" value="N"></el-option>
                                        <el-option label="停用中" value="Y"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="30">
                            <el-col :span="12">
                                <el-form-item label="品牌名稱" prop="BRAND_NAME">
                                    <el-select v-model="form.BRAND_NAME" clearable filterable style="width:100%;" allow-create>
                                        <el-option v-for="item in brandOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="公司/門店名稱" prop="NAME">
                                    <el-input v-model="form.NAME"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="屬性別" prop="ROLE_TYPE">
                                    <el-select v-model="form.ROLE_TYPE" style="width:100%;">
                                        <el-option v-for="item in roletypeOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="30">
                            <el-col :span="6">
                                <el-form-item label="付款對象" prop="PAY_PARTY">
                                    <el-select v-model="form.PAY_PARTY" style="width:100%;" @change="onChangePayParty">
                                        <el-option label="門店" value="門店"></el-option>
                                        <el-option label="品牌" value="品牌"></el-option>
                                        <el-option label="其他" value="其他"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="付款ID" prop="PAY_VENDOR">
                                    <el-input v-model="form.PAY_VENDOR"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="幣別" prop="CURRENCY">
                                    <el-input v-model="form.CURRENCY"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="儲值金警示水位" prop="ALERT_AMT">
                                    <el-input-number v-model="form.ALERT_AMT" :controls="false" style="width:100%" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="30">
                            <el-col :span="24">
                                <el-form-item label="地址" prop="ADDRESS">
                                    <el-input v-model="form.ADDRESS" style="width: calc(100% - 52px); margin-right: 4px;"></el-input>
                                    <el-button type="info" plain style="font-weight: bold;padding: 8px;" @click="onGPS()">GPS</el-button>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="30">
                            <el-col :span="12">
                                <el-form-item label="緯度(ex:25.03475314)" prop="LATI">
                                    <el-input v-model="form.LATI"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="經度(ex:121.52141519)" prop="LONG">
                                    <el-input v-model="form.LONG"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="30">
                            <el-col :span="12">
                                <el-form-item label="連絡電話" prop="PHONE_NO">
                                    <el-input v-model="form.PHONE_NO"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="清真認證" prop="HALAL">
                                    <el-select v-model="form.HALAL" style="width:100%;">
                                        <el-option label="NO" value="N"></el-option>
                                        <el-option label="YES" value="Y"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="語系" prop="LOCALE">
                                    <el-input v-model="form.LOCALE"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="30">
                            <el-col>
                                <el-form-item label="注意事項" prop="OUTLET_DESC">
                                    <el-input type="textarea" v-model="form.OUTLET_DESC" :rows="3"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="30">
                            <el-col>
                                <el-form-item label="取件(騎手)注意事項" prop="RIDER_INSTRUCTIONS">
                                    <el-input type="textarea" v-model="form.RIDER_INSTRUCTIONS" :rows="3"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="30">
                            <el-col>
                                <el-form-item label="服務條款版本" prop="AGREE_DOC_SEQ">
                                    <el-select v-model="form.AGREE_DOC_SEQ" style="width:100%;">
                                        <el-option v-for="item in docOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="30">
                            <el-col :span="12">
                                <el-row>
                                    <el-col :span="21">
                                        <el-form-item label="Pandago更新時間" prop="UPDATE_TRN_LGS">
                                            <el-input v-model="form.UPDATE_TRN_LGS" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="3">
                                        <el-form-item prop="UPDATE_TRN_LGS">
                                            <template #label>
                                                <span>&nbsp;</span>
                                            </template>
                                            <el-button type="info" plain @click="onUpdatePandago()" v-show="IDdisabled" style="width:40px">上傳</el-button>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="服務條款同意時間" prop="AGREE_TIME">
                                    <el-input v-model="form.AGREE_TIME" disabled></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="30">
                            <el-col :span="12">
                                <el-form-item label="Uber品牌代號" prop="UBER_BRAND_ID">
                                    <el-input v-model="form.UBER_BRAND_ID"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item prop="UPDATE_UBER_TIME">
                                    <label slot="label" class="el-form-item__label" style="width:100%;padding-right:0;">
                                        <span>Uber更新時間</span>
                                        <el-button type="info" plain @click="onUpdateUber()" style="width:65px;height:20px;padding:0;float:right;" :disabled="form.ROLE_TYPE!='品牌'">上傳更新</el-button>
                                    </label>
                                    <el-input v-model="form.UPDATE_UBER_TIME" disabled></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="30" v-show="IDdisabled">
                            <el-col :span="3">
                                <el-text class="mx-1">建檔人</el-text>
                            </el-col>
                            <el-col :span="9">
                                <el-text class="mx-1">{{ form.CREATE_USER }}</el-text>
                            </el-col>
                            <el-col :span="3">
                                <el-text class="mx-1">修改人</el-text>
                            </el-col>
                            <el-col :span="9">
                                <el-text class="mx-1">{{ form.EDIT_USER }}</el-text>
                            </el-col>
                        </el-row>
                        <el-row :gutter="30" v-show="IDdisabled">
                            <el-col :span="9" :offset="3">
                                <el-text class="mx-1">{{ form.CREATE_TIME }}</el-text>
                            </el-col>
                            <el-col :span="9" :offset="3">
                                <el-text class="mx-1">{{ form.EDIT_TIME }}</el-text>
                            </el-col>
                        </el-row>
                    </el-scrollbar>
                </el-form>
                <template #footer class="dialog-footer">
                    <el-button type="info" @click="dialogFormVisible = false" style="width: 150px;">取消</el-button>
                    <el-button type="primary" @click="onSubmit('form')" style="width: 150px;">存檔</el-button>
                </template>
            </el-dialog>

            <!--帳務/發票-->
            <el-dialog title="[帳務/發票資料]" width="600px" v-model="dialogInvoiceVisible" top="5vh"
                       @opened="onDialogOpen" center :lock-scroll="false" :close-on-click-modal="false">
                <el-form :model="form" :rules="rules" ref="formRef" :inline-message="true" label-position="top">
                    <el-row>
                        <el-col :span="12" style="padding: 0 6px;">
                            <el-form-item label="公司/門店代號">
                                <el-input v-model="form.VENDOR_ID" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" style="padding: 0 6px;">
                            <el-form-item label="屬性別">
                                <el-select v-model="form.ROLE_TYPE" style="width:100%;" disabled>
                                    <el-option label="門店" value="門店"></el-option>
                                    <el-option label="品牌" value="品牌"></el-option>
                                    <el-option label="餐飲平台" value="餐飲平台"></el-option>
                                    <el-option label="物流公司" value="物流公司"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12" style="padding: 0 6px;">
                            <el-form-item label="品牌名稱">
                                <el-input v-model="form.BRAND_NAME" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" style="padding: 0 6px;">
                            <el-form-item label="公司/門店名稱">
                                <el-input v-model="form.NAME" disabled></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12" style="padding: 0 6px;">
                            <el-form-item label="買受人統一編號" prop="INV_TAX_ID">
                                <el-input v-model="form.INV_TAX_ID"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col style="padding: 0 6px;">
                            <el-form-item label="買受人公司名稱" prop="INV_COMP_NAME">
                                <el-input v-model="form.INV_COMP_NAME"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12" style="padding: 0 6px;">
                            <el-form-item label="帳務-聯絡人" prop="AC_CONTACT">
                                <el-input v-model="form.AC_CONTACT"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" style="padding: 0 6px;">
                            <el-form-item label="聯絡電話" prop="AC_TEL_NO">
                                <el-input v-model="form.AC_TEL_NO"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col style="padding: 0 6px;">
                            <el-form-item label="帳單/發票寄送地址" prop="AC_ADDRESS">
                                <el-input v-model="form.AC_ADDRESS"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col style="padding: 0 6px;">
                            <el-form-item label="電子郵件" prop="AC_MAIL_ADDR">
                                <el-input v-model="form.AC_MAIL_ADDR"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col style="padding: 0 6px;">
                            <el-form-item label="注意事項" prop="AC_REMARKS">
                                <el-input type="textarea" v-model="form.AC_REMARKS" :rows="3"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row v-show="IDdisabled">
                        <el-col :span="3" style="padding: 0 6px;">
                            <el-text class="mx-1">建檔人</el-text>
                        </el-col>
                        <el-col :span="9" style="padding: 0 6px;">
                            <el-text class="mx-1">{{ form.CREATE_USER }}</el-text>
                        </el-col>
                        <el-col :span="3" style="padding: 0 6px;">
                            <el-text class="mx-1">修改人</el-text>
                        </el-col>
                        <el-col :span="9" style="padding: 0 6px;">
                            <el-text class="mx-1">{{ form.EDIT_USER }}</el-text>
                        </el-col>
                    </el-row>
                    <el-row v-show="IDdisabled">
                        <el-col :span="9" :offset="3" style="padding: 0 6px;">
                            <el-text class="mx-1">{{ form.CREATE_TIME }}</el-text>
                        </el-col>
                        <el-col :span="9" :offset="3" style="padding: 0 6px;">
                            <el-text class="mx-1">{{ form.EDIT_TIME }}</el-text>
                        </el-col>
                    </el-row>
                </el-form>
                <template #footer class="dialog-footer">
                    <el-button type="info" @click="dialogInvoiceVisible = false" style="width: 150px;">取消</el-button>
                    <el-button type="primary" @click="onInvoiceSubmit" style="width: 150px;">存檔</el-button>
                </template>
            </el-dialog>
        </div>
    </transition>

    <!-- 使用者管理 -->
    <transition name="el-fade-in-linear">
        <div v-show="showSetting" class="transition-box">
            <div id="formblock">
                <el-row style="margin-bottom: 5px;">
                    <el-text class="mx-1" style="font-size: 20px; font-weight:bold;">[使用者管理]</el-text>
                </el-row>
                <el-form :model="form" :rules="rules" ref="formRef" :inline-message="true" label-width="130px">
                    <el-row>
                        <el-col :span="22">
                            <el-form-item label="公司/門店代號:" class="userManager">
                                <el-text class="mx-1">{{ form.VENDOR_ID }}</el-text>
                            </el-form-item>
                        </el-col>
                        <el-col :span="2">
                            <el-button type="primary" round plain @click="showMain=true;showSetting=false;" style="width: 100%;float: right;">&lt;返回</el-button>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="22">
                            <el-form-item label="名稱:" class="userManager">
                                <el-text class="mx-1">{{ form.NAME }}</el-text>
                            </el-form-item>
                        </el-col>
                        <el-col :span="2">
                            <el-button type="primary" round plain @click="onAddUserClick" style="width: 100%;float: right;">新增</el-button>
                        </el-col>
                    </el-row>
                </el-form>
                <OutletUserTable ref="outletusertableRef"></OutletUserTable>
            </div>

            <!--使用者資料-->
            <OutletUserInfo ref="outletuserRef" @finish="onUserSearch"></OutletUserInfo>
        </div>
    </transition>
</template>

<script setup>
    import { ref, reactive, onBeforeMount, onMounted, nextTick } from 'vue';
    import { TabulatorFull as Tabulator } from 'tabulator-tables'; //import Tabulator library
    import { ElMessage, ElMessageBox } from 'element-plus'
    import OutletUserTable from '@/components/OutletUserTable.vue'
    import OutletUserInfo from '@/components/OutletUserInfo.vue'
    import $api from '@/utils/axios';
    import { useStore } from "vuex";
    const store = useStore();

    const showMain = ref(true);//顯示主頁面
    const showSetting = ref(false);//顯示設定頁面
    const dialogTitle = ref('');//角色資料dialog標題
    const dialogFormVisible = ref(false);//顯示dialog
    const dialogInvoiceVisible = ref(false);//顯示發票dialog
    const IDdisabled = ref(false);//編輯時ID狀態
    const Roledisabled = ref(true);
    const addOrEdit = ref('');
    const formRef = ref(null);
    const formData = ref(null);

    const brandOptions = ref([]);
    const custcodeOptions = ref([]);
    const roletypeOptions = ref([]);
    const docOptions = ref([]); //服務條款版本選項

    const outletusertableRef = ref(null);
    const outletuserRef = ref(null);

    const searchForm = reactive({
        BRAND_NAME: '',
        VENDOR_ID: '',
        NAME: '',
        AGREE_TIME: ''
    });

    const form = ref({
        OUTLET_SEQ: '',
        VENDOR_ID: '',
        CUST_CODE: '',
        DISABLE_FG: 'N',
        BRAND_NAME: '',
        NAME: '',
        PAY_PARTY: '門店',
        PAY_VENDOR: '',
        ALERT_AMT: '',
        ROLE_TYPE: '門店',
        CURRENCY: 'TWD',
        LOCALE: 'zh-TW',
        ADDRESS: '',
        LATI: '',
        LONG: '',
        PHONE_NO: '',
        HALAL: 'N',
        OUTLET_DESC: '',
        RIDER_INSTRUCTIONS: '',
        AGREE_DOC_SEQ: '',
        UPDATE_TRN_LGS: '', //Pandago更新時間
        UBER_BRAND_ID: '', //Uber品牌代號
        UPDATE_UBER_TIME: '', //Uber更新時間
        AGREE_TIME: '',
        INV_TAX_ID: '', //[帳務/發票資料]
        INV_COMP_NAME: '',
        AC_CONTACT: '',
        AC_TEL_NO: '',
        AC_ADDRESS: '',
        AC_MAIL_ADDR: '',
        AC_REMARKS: '',
        CREATE_USER: '',
        CREATE_TIME: '',
        EDIT_USER: '',
        EDIT_TIME: '',
    });

    const rules = reactive({
        CUST_CODE: [{ required: true, message: '請選擇餐飲平台', trigger: 'blur' }],
        DISABLE_FG: [{ required: true, message: '請選擇公司/門店狀態', trigger: 'blur' }],
        BRAND_NAME: [{ required: true, message: '請選擇品牌名稱', trigger: 'blur' }],
        NAME: [{ required: true, message: '請輸入公司/門店名稱', trigger: 'blur' }],
        ROLE_TYPE: [{ required: true, message: '請選擇屬性別', trigger: 'blur' }],
        CURRENCY: [{ required: true, message: '請輸入幣別', trigger: 'blur' }],
        LOCALE: [{ required: true, message: '請輸入語系', trigger: 'blur' }],
        ADDRESS: [{ required: true, message: '請輸入地址', trigger: 'blur' }],
        LATI: [{ required: true, message: '請輸入緯度', trigger: 'blur' }],
        LONG: [{ required: true, message: '請輸入經度', trigger: 'blur' }],
        PHONE_NO: [{ required: true, message: '請輸入連絡電話', trigger: 'blur' }],
        HALAL: [{ required: true, message: '請選擇清真認證', trigger: 'blur' }],
        OUTLET_DESC: [{ required: true, message: '請輸入注意事項', trigger: 'blur' }],
        RIDER_INSTRUCTIONS: [{ required: true, message: '請輸入取件(騎手)注意事項', trigger: 'blur' }],
        AC_TEL_NO: [{ required: true, message: '請輸入連絡電話', trigger: 'blur' }],
        AGREE_DOC_SEQ: [{ required: true, message: '請選擇服務條款版本', trigger: 'blur' }],
        PAY_VENDOR: [{
            validator: (rule, value, callback) => {
                if (value != '' && value != null) {
                    $api.GET('/api/Outlet/CheckVendor', { VENDOR_ID: value }
                    ).then((response) => {
                        if (response == 0) {
                            callback(new Error("輸入的付款ID不存在"));
                        } else {
                            callback();
                        }
                    });
                } else {
                    callback();
                }
            }, trigger: 'blur'
        }],
    });

    const table = ref(null); //reference to your table element
    const tabulator = ref(null); //variable to hold your table

    const onLoadTable = () => {
        $api.GET('/api/Outlet/GetTableData', searchForm
        ).then((response) => {
            tabulator.value.setData(response);
        });
    }

    const onSearch = () => {
        onLoadTable();
    }

    const onBack = () => {
        showMain.value = true;
        showSetting.value = false;
    }
    const onDialogOpen = () => {
        nextTick(() => {
            if (addOrEdit.value == 'add') {
                formRef.value.resetFields();
            } else {
                form.value = formData.value;
            }
        })
    }

    const onAddClick = () => {
        IDdisabled.value = false;
        addOrEdit.value = 'add';
        dialogFormVisible.value = true;
        dialogTitle.value = '[新增]';

        if (localStorage.getItem('VendorType') == '餐飲平台') {
            form.value.CUST_CODE = localStorage.getItem('CustCode');
            Roledisabled.value = true;
        } else if (localStorage.getItem('VendorType') == '平台管理') {
            Roledisabled.value = false;
        } else {
            Roledisabled.value = true;
            rules.CUST_CODE = [{ required: false, message: '請選擇餐飲平台', trigger: 'blur' }];
        }
    }

    const onEditClick = (e, cell) => {
        formData.value = JSON.parse(JSON.stringify(cell.getData()));
        console.log(formData.value);

        IDdisabled.value = true;
        addOrEdit.value = 'edit';
        dialogFormVisible.value = true;
        dialogTitle.value = '[編輯]';
        Roledisabled.value = true;
    }

    const onInvoiceClick = (e, cell) => {
        formData.value = JSON.parse(JSON.stringify(cell.getData()));

        dialogInvoiceVisible.value = true;
        addOrEdit.value = 'edit';
    }

    // 使用者
    const onUserClick = (e, cell) => {
        form.value = JSON.parse(JSON.stringify(cell.getData()));

        showMain.value = false;
        showSetting.value = true;
        const tableForm = { "COMP_ID": form.value.VENDOR_ID };
        outletusertableRef.value.onSearch(tableForm);
    }

    const onUserSearch = () => {
        const tableForm = { "COMP_ID": form.value.VENDOR_ID };
        outletusertableRef.value.onSearch(tableForm);
    }

    const onAddUserClick = () => {
        outletuserRef.value.onAddClick(form.value.VENDOR_ID);
    }

    const onChangePayParty = () => {
        if (form.value.PAY_PARTY == "門店") form.value.PAY_VENDOR = form.value.VENDOR_ID;
        else if (form.value.PAY_PARTY == "品牌") {
            $api.GET('/api/Outlet/GetPayVendorId', {
                CUST_CODE: form.value.CUST_CODE, BRAND_NAME: form.value.BRAND_NAME
            }).then((response) => {
                form.value.PAY_VENDOR = response;
            });
        } else {
            form.value.PAY_VENDOR = "";
        }
    }

    let roundDecimal = function (val, precision) {
        return Math.round(Math.round(val * Math.pow(10, (precision || 0) + 1)) / 10) / Math.pow(10, (precision || 0));
    }

    const onGPS = () => {
        var addr = form.value.ADDRESS;
        if (addr == null || addr == '') {
            formRef.value.validateField('ADDRESS', () => null)
        } else {
            // 取經緯度(勤崴OpenApi)
            $api.GET('/api/Outlet/GetLatLng', {
                ADDRESS: addr, URL_ADDR: '/CompSet'
            }).then((response) => {
                //console.log(response);
                form.value.LATI = roundDecimal(response.lat, 8).toString();
                form.value.LONG = roundDecimal(response.lng, 8).toString();
            });
        }
    }

    //將資料更新到Pandago
    const onUpdatePandago = () => {
        formRef.value.validate((valid) => {
            if (valid) {
                form.value.PHONE_NO = form.value.PHONE_NO.replaceAll("-", "");
                if (form.value.PHONE_NO.substring(0, 1) == "0") {
                    form.value.PHONE_NO = "+886" + form.value.PHONE_NO.substring(1, (form.value.PHONE_NO.length));
                }
                var today = new Date();
                const formData = JSON.parse(JSON.stringify(form.value));
                formData.UPDATE_TRN_LGS = today.toLocaleString([], { year: "numeric", month: "2-digit", day: "2-digit", hour12: false, hour: "2-digit", minute: "2-digit", second: "2-digit" });

                $api.POST('/api/Outlet/UpdatePandago/', formData
                ).then((res) => {
                    if (res == "1") {
                        ElMessageBox.alert('上傳成功!', '提示', {
                            confirmButtonText: '確定'
                        });
                        form.value.UPDATE_TRN_LGS = formData.UPDATE_TRN_LGS; //更新pandago上傳時間
                    } else {
                        console.log(res);
                        var message = (res == "0" || res == "-1") ? "" : "<br />" + res;
                        ElMessageBox.alert('上傳失敗!' + message, '提示', {
                            confirmButtonText: '確定',
                            dangerouslyUseHTMLString: true,
                        });
                    }
                }).catch((error) => {
                    console.log(error);
                });
            }
        })
    }

    //將資料更新到Uber
    const onUpdateUber = () => {

    }

    const onSubmit = () => {
        formRef.value.validate((valid) => {
            if (valid) {
                if (form.value.ROLE_TYPE == '門店' && form.value.PAY_PARTY == '品牌') {
                    let obj = {};
                    obj = brandOptions.value.find((item) => {
                        return item.label === form.value.BRAND_NAME;
                    });
                    if (obj == undefined) {
                        ElMessageBox.alert('輸入的品牌名稱不存在!', '提示', {
                            confirmButtonText: '確定'
                        });
                        return false;
                    }
                }

                form.value.PHONE_NO = form.value.PHONE_NO.replaceAll("-", "");
                if (form.value.PHONE_NO.substring(0, 1) == "0") {
                    form.value.PHONE_NO = "+886" + form.value.PHONE_NO.substring(1, (form.value.PHONE_NO.length));
                }

                if (addOrEdit.value == 'add') {
                    //console.log('add');
                    $api.POST('/api/Outlet/Add', form.value
                    ).then((res) => {
                        ElMessageBox.alert('新增成功!', '提示', {
                            confirmButtonText: '確定',
                            callback: action => {
                                dialogFormVisible.value = false;
                                onLoadTable();
                            }
                        });
                    }).catch(() => {
                        ElMessageBox.alert('新增失敗', '提示', {
                            confirmButtonText: '確定'
                        });
                    });
                } else if (addOrEdit.value == 'edit') {
                    $api.POST('/api/Outlet/Edit', form.value
                    ).then((res) => {
                        if (res > 0) {
                            ElMessageBox.alert('修改成功!', '提示', {
                                confirmButtonText: '確定',
                                callback: action => {
                                    dialogFormVisible.value = false;
                                    // 畫面只更新該筆資料，避免存檔後跳到第一頁第一筆資料
                                    tabulator.value.updateData([form.value]);
                                }
                            });
                        } else {
                            ElMessageBox.alert('修改失敗', '提示', {
                                confirmButtonText: '確定'
                            });
                        }
                    });
                }
            }
        })
    }

    const onInvoiceSubmit = () => {
        formRef.value.validate((valid) => {
            if (valid) {
                $api.POST('/api/Outlet/SaveInvoice', form.value
                ).then((res) => {
                    if (res > 0) {
                        ElMessageBox.alert('儲存成功', '提示', {
                            confirmButtonText: '確定',
                            callback: action => {
                                dialogInvoiceVisible.value = false;
                                onLoadTable();
                            }
                        });
                    } else {
                        ElMessageBox.alert('儲存失敗', '提示', {
                            confirmButtonText: '確定'
                        });
                    }
                });
            }
        });
    }

    const editIcon = (cell, formatterParams) => {
        return '<i class="el-icon"><svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path d="m199.04 672.64 193.984 112 224-387.968-193.92-112-224 388.032zm-23.872 60.16 32.896 148.288 144.896-45.696L175.168 732.8zM455.04 229.248l193.92 112 56.704-98.112-193.984-112-56.64 98.112zM104.32 708.8l384-665.024 304.768 175.936L409.152 884.8h.064l-248.448 78.336L104.32 708.8zm384 254.272v-64h448v64h-448z" fill="currentColor"></path></svg></i>';
    }
    const ReportIcon = (cell, formatterParams) => {
        return '<i class="el-icon"><svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" data-v-029747aa=""><path fill="currentColor" d="M192 128v768h640V128H192zm-32-64h704a32 32 0 0 1 32 32v832a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32zm160 448h384v64H320v-64zm0-192h192v64H320v-64zm0 384h384v64H320v-64z"></path></svg></i>';
    }

    const getOptions = async () => {
        $api.GET('/api/Outlet/GetBrandOptions')
            .then((response) => {
                brandOptions.value = response;
            });
        $api.GET('/api/Outlet/GetCustCodeOptions')
            .then((response) => {
                custcodeOptions.value = response;
            });
        $api.GET('/api/DocSet/GetOptions')
            .then((response) => {
                docOptions.value = response;
            });
    };

    onBeforeMount(() => {
        //options
        getOptions();
        switch (localStorage.getItem("VendorType")) {
            case "品牌":
                roletypeOptions.value = [{ value: '門店', label: '門店' }, { value: '品牌', label: '品牌' }];
                break;
            case "餐飲平台":
                roletypeOptions.value = [{ value: '門店', label: '門店' }, { value: '品牌', label: '品牌' }];
                break;
            case "平台管理":
                roletypeOptions.value = [{ value: '門店', label: '門店' }, { value: '品牌', label: '品牌' },
                { value: '餐飲平台', label: '餐飲平台' }, { value: '運輸公司', label: '運輸公司' }, { value: '平台管理', label: '平台管理' }];
                break;
        }
    });

    onMounted(() => {
        //instantiate Tabulator when element is mounted
        tabulator.value = new Tabulator(table.value, {
            locale: "zh-tw",
            layout: "fitColumns",      //fit columns to width of table
            maxHeight: "calc(100vh - 392px)", //do not let table get bigger than the height of its parent element
            columnHeaderVertAlign: "middle", //align header contents to middle of cell
            pagination: true,       //paginate the data
            paginationSize: 50,         //allow 50 rows per page of data
            paginationSizeSelector: [50, 100, 200],
            index: "OUTLET_SEQ", //set the index field to the field.
            columns: [
                { title: "序號", formatter: "rownum", width: 50, headerHozAlign: "center", hozAlign: "center", headerSort: false },
                { title: "品牌名稱", field: "BRAND_NAME", headerHozAlign: "center", hozAlign: "center", headerSort: true },
                { title: "公司/門店代碼", field: "VENDOR_ID", headerHozAlign: "center", hozAlign: "center", headerSort: true },
                { title: "公司/門店名稱", field: "NAME", headerHozAlign: "center", hozAlign: "center", headerSort: false },
                { title: "屬性", field: "ROLE_TYPE", width: 90, headerHozAlign: "center", hozAlign: "center", headerSort: false },
                { title: "公司/門店地址", field: "ADDRESS", width: 300, headerHozAlign: "center", hozAlign: "center", headerSort: false },
                {
                    title: "合約", field: "AGREE_TIME", width: 50, headerHozAlign: "center", hozAlign: "center", headerSort: false, formatter: function (cell, formatterParams, onRendered) {
                        if (cell.getValue() == "") {
                            return '';
                        } else {
                            return 'Y';
                        }
                    }
                },
                {
                    title: "停用", field: "DISABLE_FG", width: 50, headerHozAlign: "center", hozAlign: "center", headerSort: false, formatter: function (cell, formatterParams, onRendered) {
                        if (cell.getValue() == 'N') {
                            return '';
                        } else {
                            return "<span style='color:red;'>" + cell.getValue() + "</span>";
                        }
                    }
                },
                { title: "編輯", field: "edit", formatter: editIcon, width: 50, headerHozAlign: "center", hozAlign: "center", headerSort: false, cellClick: onEditClick },
                { title: "發票", field: "bill", formatter: editIcon, width: 50, headerHozAlign: "center", hozAlign: "center", headerSort: false, cellClick: onInvoiceClick },
                { title: "使用者", field: "report", formatter: ReportIcon, width: 60, headerHozAlign: "center", hozAlign: "center", headerSort: false, cellClick: onUserClick }
            ],
            langs: {
                "zh-tw": {
                    "pagination": {
                        "page_size": "選擇筆數",
                        "first": "第一頁",
                        "last": "最後一頁",
                        "prev": "上一頁",
                        "next": "下一頁",
                    }
                }
            },
        });
        tabulator.value.on("tableBuilt", function () {
            if (!store.getters.check_auth('MODIFY')) {
                tabulator.value.hideColumn('edit');
            }
        });
    })

</script>

<style>
    .userManager {
        margin-bottom: 3px;
    }

        .userManager .el-form-item__label {
            font-size: 17px;
            margin-left: 2px;
        }
</style>
